import clsx from "clsx";
import React from "react";
import Scrollbar from "react-scrollbars-custom";
import { setScrollerPositioning } from "../setScrollerPositioning";

/* eslint react/prop-types: 0 */

interface ResultsScrollbarProps {
	children: React.ReactNode;
	forPrint?: boolean;
	tableClass?: string;
}

export function ResultsScrollbar({
	children,
	forPrint,
	tableClass,
}: ResultsScrollbarProps) {
	setScrollerPositioning();

	const classes = clsx("results", tableClass, {
		"results-for-print": forPrint,
	});

	return (
		<Scrollbar
			createContext={!forPrint}
			renderer={(props) => {
				const { elementRef, ...restProps } = props;
				return (
					<div {...restProps} ref={elementRef} className={classes} />
				);
			}}
			wrapperProps={{
				renderer: (props) => {
					const { elementRef, ...restProps } = props;
					return (
						<div
							{...restProps}
							ref={elementRef}
							className="results-scroller-wrapper"
						/>
					);
				},
			}}
			scrollerProps={{
				renderer: (props) => {
					const { elementRef, ...restProps } = props;
					return (
						<div
							{...restProps}
							ref={elementRef}
							className="results-scroller"
						/>
					);
				},
			}}
			contentProps={{
				renderer: (props) => {
					const { elementRef, ...restProps } = props;
					return (
						<div
							{...restProps}
							ref={elementRef}
							className="results-scroller-content"
						>
							{children}
						</div>
					);
				},
			}}
			trackXProps={{
				renderer: (props) => {
					const { elementRef, ...restProps } = props;
					return (
						<div
							{...restProps}
							ref={elementRef}
							className="results-scroller-track-x"
						/>
					);
				},
			}}
			thumbXProps={{
				renderer: (props) => {
					const { elementRef, ...restProps } = props;
					return (
						<div
							{...restProps}
							ref={elementRef}
							className="results-scroller-thumb-x"
						/>
					);
				},
			}}
			trackYProps={{
				renderer: (props) => {
					const { elementRef, ...restProps } = props;
					return (
						<span
							{...restProps}
							ref={elementRef}
							className="results-scroller-track-y"
						/>
					);
				},
			}}
			thumbYProps={{
				renderer: (props) => {
					const { elementRef, ...restProps } = props;
					return (
						<span
							{...restProps}
							ref={elementRef}
							className="results-scroller-thumb-y"
						/>
					);
				},
			}}
			noScrollY={true}
		/>
	);
}
